import { FormatMask } from './FormatMask';

/**
 * Formata o identificador do contato de forma amigável.
 *
 * - WhatsApp (números): formata como +55 (XX) XXXXX-XXXX 🇧🇷
 * - WebChat (sessionId): mostra "🌐 WebChat"
 * - Telegram: mostra "✈️ Telegram"
 * - Outros: retorna o valor original
 */
const formatSerializedId = (serializedId) => {
  if (!serializedId) return serializedId;

  // ✅ WebChat: sessionId começa com "webchat_"
  if (typeof serializedId === 'string' && serializedId.startsWith('webchat_')) {
    return '🌐 WebChat';
  }

  // ✅ Telegram: começa com "telegram_"
  if (typeof serializedId === 'string' && serializedId.startsWith('telegram_')) {
    return '✈️ Telegram';
  }

  // ✅ Facebook/Instagram: começa com "facebook_" ou "instagram_"
  if (typeof serializedId === 'string' && serializedId.startsWith('facebook_')) {
    return '📘 Facebook';
  }
  if (typeof serializedId === 'string' && serializedId.startsWith('instagram_')) {
    return '📷 Instagram';
  }

  const formatMask = new FormatMask();
  const number = serializedId?.replace('@c.us', '');

  return formatMask.setPhoneFormatMask(number)?.replace('+55', '🇧🇷');
};

export default formatSerializedId;
